"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = void 0;
const sleep = (timeoutInMs = 0) => {
    return new Promise((resolve) => {
        setTimeout(resolve, timeoutInMs);
    });
};
exports.sleep = sleep;
//# sourceMappingURL=promiseUtils.js.map